import { Option } from '@sapphire/result';

import { SurveyMarginFormState, SurveyMarginSnapshot } from '@ps/survey-utils';

import { SubmittableForm } from '../../../utils';

/**
 * An absent margin form means the buyer has no Target Margin story at all, so
 * it is never what blocks a save. Only a form that was actually filled in and
 * is invalid does.
 */
export function isMarginFormSubmittable(
  margin: SurveyMarginFormState,
): boolean {
  return !margin.value || margin.valid;
}

/**
 * Both values have to be present for the margin keys to go out — the backend
 * derives SCPI from the pair, so writing one without the other is meaningless.
 */
export function marginSnapshot(
  margin: SurveyMarginFormState,
): Option<SurveyMarginSnapshot> {
  return Option.from(margin.value).map(
    ({ buyerCpi, targetMargin, userAcceptedMargin }) => ({
      buyerCpi,
      targetMargin: targetMargin ?? 0,
      userAcceptedMargin,
    }),
  );
}

export function marginGateForm(
  marginForm: SurveyMarginFormState,
): SubmittableForm {
  const submittable = isMarginFormSubmittable(marginForm);

  return {
    valid: submittable,
    error: marginForm.errors[0]?.message ?? null,
    showErrors: () => !submittable,
  };
}
